import { createRouter, createWebHistory } from 'vue-router'
import Layout from '../components/layout.vue'
import {
  getEntryByLoginPath,
  getEntryByProtectedPath,
  getHomePathByEntry,
  getPreferredEntry,
  getLoginPathByEntry,
  hasTokenByEntry,
  isLoginPath
} from '@/utils/loginEntry'

const routes = [
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: () => import('../views/login/AdminLogin.vue')
  },
  {
    path: '/report/login',
    name: 'ReportLogin',
    component: () => import('../views/login/ReportLogin.vue')
  },
  {
    path: '/verify/login',
    name: 'VerifyLogin',
    component: () => import('../views/login/VerifyLogin.vue')
  },
  {
    path: '/report/reportCenter',
    name: 'ReportCenter',
    component: () => import('../views/report/ReportCenter.vue')
  },
  {
    path: '/report/reportCreate',
    name: 'ReportCreate',
    component: () => import('../views/report/ReportCreate.vue')
  },
  {
    path: '/report/reportDetail',
    name: 'ReportDetail',
    component: () => import('../views/report/ReportDetail.vue')
  },
  {
    path: '/verify/verifyCenter',
    name: 'VerifyCenter',
    component: () => import('../views/verify/VerifyCenter.vue')
  },
  {
    path: '/verify/verifyDetail',
    name: 'VerifyDetail',
    component: () => import('../views/verify/VerifyDetail.vue')
  },
  {
    path: '/verify/verifyCluePool',
    name: 'VerifyCluePool',
    component: () => import('../views/verify/VerifyCluePool.vue')
  },
  {
    path: '/verify/verifyClueDetail',
    name: 'VerifyClueDetail',
    component: () => import('../views/verify/VerifyClueDetail.vue')
  },
  {
    path: '/verify/verifyNotice',
    name: 'VerifyNotice',
    component: () => import('../views/verify/VerifyNotice.vue')
  },
  {
    path: '/',
    redirect: () => getHomePathByEntry(getPreferredEntry()),
  },
  {
    path: '/admin',
    component: Layout,
    redirect: '/admin/manageAccount',
    children: [
      { path: 'platformAccount', redirect: '/admin/manageAccount' },
      { path: 'manageAccount', name: 'ManageAccount', component: () => import('../views/admin/ManageAccount.vue') },
      { path: 'productList', name: 'ProductList', component: () => import('../views/admin/ProductList.vue') },
      { path: 'dictionaryList', name: 'DictionaryList', component: () => import('../views/admin/DictionaryList.vue') },
      { path: 'clueList', name: 'ClueList', component: () => import('../views/admin/ClueList.vue') },
      { path: 'clueGroupList', name: 'ClueGroupList', component: () => import('../views/admin/ClueGroupList.vue') }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to) => {
  const routeEntry = getEntryByProtectedPath(to.path) || getEntryByLoginPath(to.path) || getPreferredEntry()
  const allowAnonymousReportCreate = to.path === '/report/reportCreate' && to.query.anonymous === '1'

  if (isLoginPath(to.path)) {
    return hasTokenByEntry(routeEntry) ? getHomePathByEntry(routeEntry) : true
  }

  if (allowAnonymousReportCreate) {
    return true
  }

  return hasTokenByEntry(routeEntry) ? true : getLoginPathByEntry(routeEntry)
})

export default router
